import React, { useEffect, useRef } from "react"
import Layout from "../components/Layout"
import Countdown from "react-countdown"
import { graphql } from "gatsby"
// import Img from "gatsby-image"
import { StaticImage } from "gatsby-plugin-image"
import blackNoise from "../../static/black-noise.gif"
import downArrow from "../../static/down-arrow.svg"
import audio from "../../static/aykunna.mp3"
import pauseBtn from "../../static/pause.png"
import playBtn from "../../static/play.png"
import { Link } from "gatsby"
import ReactHowler from 'react-howler'
import { InView,useInView } from 'react-intersection-observer'
import Vimeo from '@u-wave/react-vimeo';

export default function Home({ data }) {

  const [play, setPlay] = React.useState(true)
  const [volume, setVolume] = React.useState(0)

  let audioControl;

  const videoRef = useRef();

  const playPause = () => {
    setPlay(!play);
  }

  if (play) {
    audioControl = <img src={playBtn} alt="" onClick={() => playPause()} />;
  } else {
    audioControl = <img src={pauseBtn} alt="" onClick={() => playPause()} />;
  }

  const Completionist = () => <span>You are good to go!</span>
  const renderer = ({ days, hours, minutes, seconds, completed }) => {
    if (completed) {
      // Render a completed state
      return <Completionist />
    } else {
      // Render a countdown
      return <div className={"countdown flex-center-rw"}>
        <div>{days}<span>Days</span></div>
        <div>{hours}<span>Hours</span></div>
        <div>{minutes}<span>Minutes</span></div>
        <div>{seconds}<span>Seconds</span></div>
      </div>
    }
  }

  const { ref, inView, entry } = useInView({
    /* Optional options */
    threshold: 0.15,
    triggerOnce: true
  });

  return (
    <Layout>
      <div className={"w-100 rel aykunna-part-1"}>
        <svg className={"abs-center aykunna-animation"} viewBox="0 0 414.551 93.018" xmlns="http://www.w3.org/2000/svg">
          <g id="svgGroup" strokeLinecap={"round"} fillRule={"evenodd"} fontSize={"9pt"} stroke="#fff"
             strokeWidth={"0.25mm"} fill="#fff" style={{ stroke: "#fff", strokeWidth: "0.5mm", fill: "#fff" }}>
            <path
              d="M 177.539 72.021 L 164.014 72.021 L 139.209 49.805 L 139.209 72.021 L 129.639 72.021 L 129.639 0 L 139.209 0 L 139.209 40.527 L 162.012 20.02 L 175.537 20.02 L 147.607 45.117 L 177.539 72.021 Z M 292.529 29.639 L 292.529 72.021 L 282.91 72.021 L 282.91 29.639 L 256.104 29.639 L 256.104 72.021 L 246.533 72.021 L 246.533 20.02 L 256.104 20.02 L 256.104 29.199 A 9.62 9.62 0 0 1 256.982 25.61 Q 257.764 23.926 259.058 22.681 A 9.568 9.568 0 0 1 262.061 20.728 Q 263.77 20.02 265.723 20.02 L 282.91 20.02 Q 284.912 20.02 286.67 20.776 A 9.681 9.681 0 0 1 289.722 22.827 A 9.681 9.681 0 0 1 291.772 25.879 Q 292.529 27.637 292.529 29.639 Z M 354.541 29.639 L 354.541 72.021 L 344.922 72.021 L 344.922 29.639 L 318.115 29.639 L 318.115 72.021 L 308.545 72.021 L 308.545 20.02 L 318.115 20.02 L 318.115 29.199 A 9.62 9.62 0 0 1 318.994 25.61 Q 319.775 23.926 321.069 22.681 A 9.568 9.568 0 0 1 324.072 20.728 Q 325.781 20.02 327.734 20.02 L 344.922 20.02 Q 346.924 20.02 348.682 20.776 A 9.681 9.681 0 0 1 351.733 22.827 A 9.681 9.681 0 0 1 353.784 25.879 Q 354.541 27.637 354.541 29.639 Z M 184.521 62.402 L 184.521 20.02 L 194.092 20.02 L 194.092 62.402 L 220.898 62.402 L 220.898 20.02 L 230.518 20.02 L 230.518 72.021 L 220.898 72.021 L 220.898 63.232 Q 220.752 65.039 219.922 66.65 Q 219.092 68.262 217.798 69.458 Q 216.504 70.654 214.844 71.338 Q 213.184 72.021 211.328 72.021 L 194.092 72.021 A 9.285 9.285 0 0 1 190.381 71.265 A 9.681 9.681 0 0 1 187.329 69.214 A 9.681 9.681 0 0 1 185.278 66.162 Q 184.521 64.404 184.521 62.402 Z M 88.135 93.018 L 78.564 93.018 L 89.453 67.334 L 69.043 20.02 L 79.15 20.02 L 94.336 55.811 L 109.521 20.02 L 119.629 20.02 L 88.135 93.018 Z M 370.557 62.402 L 370.557 49.316 A 9.319 9.319 0 0 1 371.136 46.019 A 8.893 8.893 0 0 1 371.313 45.581 A 10.064 10.064 0 0 1 373.364 42.529 A 9.48 9.48 0 0 1 376.416 40.454 A 9.285 9.285 0 0 1 380.127 39.697 L 404.932 39.697 L 404.932 29.639 L 373.535 29.639 L 373.535 20.02 L 404.932 20.02 Q 406.934 20.02 408.691 20.776 A 9.681 9.681 0 0 1 411.743 22.827 A 9.681 9.681 0 0 1 413.794 25.879 Q 414.551 27.637 414.551 29.639 L 414.551 72.021 L 404.932 72.021 L 404.932 63.232 Q 404.785 65.039 403.955 66.65 Q 403.125 68.262 401.831 69.458 Q 400.537 70.654 398.877 71.338 Q 397.217 72.021 395.361 72.021 L 380.127 72.021 A 9.285 9.285 0 0 1 376.416 71.265 A 9.681 9.681 0 0 1 373.364 69.214 A 9.681 9.681 0 0 1 371.313 66.162 Q 370.557 64.404 370.557 62.402 Z M 27.002 2.002 L 37.012 2.002 L 64.014 72.021 L 54.004 72.021 L 47.803 55.908 L 16.211 55.908 L 10.01 72.021 L 0 72.021 L 27.002 2.002 Z M 32.031 15.039 L 20.02 45.898 L 43.945 45.898 L 32.031 15.039 Z M 380.127 49.316 L 380.127 62.402 L 404.932 62.402 L 404.932 49.316 L 380.127 49.316 Z"
              vectorEffect={"non-scaling-stroke"} />
          </g>
        </svg>
        <a className={"go-down abs"} href={"#home-page-discography"}>Check More <img src={downArrow} alt="" /></a>
      </div>
      <div className={"w-100 rel aykunna-part-2"} id={"home-page-discography"}>
        <div style={{position:"relative"}} ref={ref}>
          <Vimeo
            ref={videoRef}
            video="700251745"
            responsive={true}
            autoplay={true}
            muted={true}
            volume={0}
            loop={true}
            // onPlay={increaseVolume}
          />
          {/*<iframe*/}
          {/*  ref={videoRed}*/}
          {/*  src={inView ? "https://player.vimeo.com/video/700251745?h=ed899cc3b8&amp;badge=0&amp;autopause=0&autoplay=1&loop=0&amp;player_id=0&amp;app_id=58479" : "https://player.vimeo.com/video/700251745?h=ed899cc3b8&amp;badge=0&amp;autopause=0&autoplay=0&loop=0&amp;player_id=0&amp;app_id=58479"}*/}
          {/*  frameBorder="0" allow={"autoplay; fullscreen; picture-in-picture"} allowFullScreen*/}
          {/*  style={{position:"absolute",top:0,left:0,width:"100%",height:"100%"}}*/}
          {/*  title="AYKUNNA | Official Promo Video"></iframe>*/}
        </div>
        <script src={"https://player.vimeo.com/api/player.js"}></script>
      </div>
      <div className={"w-100 rel aykunna-part-3 flex-center-rw"}>
        <div className={"latest-content"}>
          <h2>Aykunna - 2019 Beat</h2>
          <p>Alienum phaedrum torquatos nec eu, vis detraxit periculis ex, nihil expetendis in mei. Mei an pericula
            euripidis, hinc partem ei est. Eos ei nisl graecis, vix aperiri consequat an. Eius lorem tincidunt vix at,
            vel. </p>
        </div>
        <div className={"latest-music"}>
          <h4>01. Aykunna Beat</h4>
          <div style={{ cursor: "pointer" }}>
            {audioControl}
            <ReactHowler
              src={audio}
              playing={!play}
            />
          </div>
        </div>
      </div>
      <div className={"w-100 rel aykunna-part-4 flex-center-cl"}>
        <h2>Upcoming beat</h2>
        <Countdown date={Date.now() + 500000000} renderer={renderer} />
      </div>
    </Layout>
  )
}
